<template>
  <div>
    <TeCourseWebdesignCover
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <TeCommonPagenav class="hidden md:block">
      <template #courseicon>
        <FontAwesomeIcon
          :icon="faObjectGroup"
          class="fa-fw mr-2 size-5"
        />
      </template>
      <template #coursename>
        Webデザイン<span class="hidden md:inline">コース</span>
      </template>
    </TeCommonPagenav>

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCommonBannerSettlement
      v-if="BannerNameForShowing === 'settlement'"
      :entry-settlement-time-limit="entrySettlementTimeLimit"
      :entry-payment-url="entryPaymentUrl"
    />
    <TeCommonBannerTimelimit
      v-if="BannerNameForShowing === 'discount'"
      :entry-discount-time-limit="entryDiscountTimeLimit"
    />
    <TeCommonBannerCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />
    <TeCourseAbout>
      <template #title>
        Webデザインコースについて
      </template>
      <template #discription>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          Webデザイン、Webサイト制作、バナー制作の実務経験までを網羅した、
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          Webデザイナーを本気で目指す方のための学習プログラム。
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          現役プロの講師のサポートを受けながら、
        </p>
        <p class="co-display-10 mb-0 inline text-co-gray-500 md:block">
          デザインの学習と実績を積み、副業や転職を目指します。
        </p>
      </template>
    </TeCourseAbout>
    <TeCourseWebdesignPoint />
    <section
      id="interview"
      class="co-bg-striped py-20"
    >
      <div class="co-container-lg px-4">
        <h2 class="te-section-h2-title mb-6 text-center font-bold leading-normal">
          <span class="block md:inline">卒業生に受講中の</span>
          <span class="block md:inline">実体験を聞いてみた</span>
        </h2>
        <p class="mb-8 text-left text-co-gray-500 md:text-center">
          「ちゃんと最後まで学習できた？」「サポート内容はどうだった？」<br class="hidden md:block">
          そんな不安や疑問について、実際の卒業生にインタビューしました。
        </p>
      </div>
      <div class="co-container-xs px-4">
        <div>
          <iframe
            src="//www.youtube.com/embed/dAzgla6v1zE?rel=0&amp;showinfo=0"
            allowfullscreen="true"
            frameborder="0"
            class="aspect-[16/9] w-full"
          />
        </div>
      </div>
    </section>
    <TeCourseWebdesignTarget />
    <TeCourseWebdesignGraduate />
    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-first"
    /> -->
    <TeCourseWebdesignOutput />
    <TeCourseWebdesignCurriculum />
    <TeCommonBannerAdobe />
    <TeCourseWebdesignMerit />
    <TeCourseWebdesignWork />
    <!-- 挫折させないパーソナルメンターサポート -->
    <section
      id="mentor-support"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pt-20">
        <h2 class="co-heading-2-caption">
          挫折させない<span class="block md:inline">パーソナルメンターサポート</span>
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          学習時の「わからない」「続かない」を解消し、挫折をなくします。
          <br class="hidden md:block">
          実務で培った技術とノウハウで受講生一人ひとりをサポートします。
        </h3>
        <div class="flex flex-col justify-center gap-x-8 sm:px-36 lg:flex-row lg:px-0">
          <TeCommonMentorSupportMentoring />

          <TeCommonMentorSupportChatSupport />

          <TeCommonMentorSupportIssueReview />
        </div>
      </div>
      <TeCommonMentorSupportAboutFlow>
        <template #flowOriginalText>
          オリジナルデザインサイトの公開
        </template>
        <template #learningLead>
          パーソナルメンターとの定期的なメンタリング、チャットサポート、課題レビュー、宿題に取り組みながらオリジナルWebサイトを制作できるスキルを身につけます。
        </template>
        <template #originalTitle>
          オリジナルWebサイトの公開までサポート
        </template>
        <template #originalLead>
          受講目的や習得スキルに合わせて、自分のアイデアをデザインから起こし、オリジナルWebサイトを公開するまで徹底サポートします。
        </template>
      </TeCommonMentorSupportAboutFlow>

      <TeCommonMentorSupportMentor>
        <template #mentor>
          Webデザイナー
        </template>
        <template #mentorImage1>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-masuda.jpg"
            alt="Naoko Masuda"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName1>
          Naoko
          <br>
          Masuda
        </template>
        <template #mentorProfile1>
          HTMLという言葉も知らなかった状態から勉強をし始めて2年後にフリーランスとして独立。現在ではWordPressを得意とするWebデザイナー・エンジニアとして活躍しています。
        </template>
        <template #mentorMessage1>
          働き方の見直しや昨今のご時世でWebデザイナーやエンジニアを希望する人は急激に増えています。じゃあ今から勉強しても遅い？全然そんなことありません。スキル獲得のその先にある「なりたい自分」になるための第一歩のお手伝いをいたします。
        </template>
        <template #mentorImage2>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-sasagawa.jpg"
            alt="Kiyoshi Sasagawa"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName2>
          Kiyoshi
          <br>
          Sasagawa
        </template>
        <template #mentorProfile2>
          20年ほど前から独学でHTMLを始める。CSS・JavaScript/jQueryを得意とし、WordPress・Photoshop・Illustratorなどの技術にも明るい。印刷物系のデザイナーの経験を活かし、コーディングの傍らデザイン面のコンサルを行うこともある。
        </template>
        <template #mentorMessage2>
          最初は誰しもどうしたら良いか解らないことだらけですよね。目先のことだけで無く、先々のことを考えるなら自力で対応できるスキルが必要になります。そこまでを考えて、コースを終えた後も必要なスキルを伸ばしていけるようお手伝いしていきます。一緒に頑張りましょう！
        </template>
      </TeCommonMentorSupportMentor>
      <TeCommonMentorSupportReason>
        <template #mentorType>
          Webデザイナー
        </template>
      </TeCommonMentorSupportReason>
    </section>

    <TeCommonLearningCycle>
      <template #image>
        <img
          class="mx-auto w-3/4 sm:w-1/2 md:w-full"
          src="~/assets/images/Te/TeCommon/LearningCycle/cycle-design.svg"
          loading="lazy"
          alt="学習サイクル デザイン"
        >
      </template>
      <template #catchTwo>
        <span>Webサイトを</span>
        <span class="text-co-primary-500">デザインする</span>
      </template>
      <template #textTwo>
        <span>知識を「学ぶ」だけでなく、実際に「使える」ようになるために、実践に近い形でデザインします。</span>
        <span>チュートリアル形式のカリキュラムを進めることで、Webデザインを身につけます。</span>
      </template>
      <template #textThree>
        <span>自習していてわからないところを1人で悩まずに、すぐにメンターに聞いて解決することが重要です。</span>
        <span>オンラインで常駐している現役Webデザイナーのメンターが、あなたの質問に素早く回答します。</span>
      </template>
    </TeCommonLearningCycle>

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-second"
    /> -->

    <!-- 受講生の事例 -->
    <TeCourseWebdesignExample />

    <!-- テックアカデミーキャリア -->
    <TeCourseWebdesignCareerSupport />

    <TeCommonCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <section
      id="price"
      class="co-bg-striped"
    >
      <!-- 無料相談割引コード -->
      <TeCommonBannerTimeLimitCpnCode
        v-if="BannerNameForShowing === 'campaign'"
        :entry-campaign="entryCampaign"
      />

      <div class="co-container-lg px-4 py-20 xl:px-0">
        <h2 class="co-display-7 mb-[3.25rem] text-center">
          料金
        </h2>

        <TeCommonPriceTimeLimit
          v-if="BannerNameForShowing === 'discount'"
          :entry-discount-time-limit="entryDiscountTimeLimit"
        />

        <TeCoursePriceTable
          :course="course"
          :latest-cohort="latestCohort"
          :current-promotion="currentPromotion"
          :student="true"
          :mentoring="true"
          :chat-support="true"
          :badge-sakiwari-and-campaign="true"
        >
          <template #chatSupportTime>
            24時間以内に回答
          </template>
          <template #additionalFees>
            Adobe Creative Cloud Pro 個人版のご利用に対し、3ヶ月分クーポンを発行いたします。3ヶ月以降、ご利用になる場合は別途料金（月額7,780円、2025年7月30日時点）が発生します。受講料には含まれませんのでご注意ください。
          </template>
        </TeCoursePriceTable>

        <TeCoursePriceGreatPlan :course="course" />

        <TeCoursePriceInstallments :course="course" />

        <!-- 参加条件 -->
        <TeCommonPriceParticipationconditions>
          <template #conditionList>
            <li class="mb-2">
              必要なメンタリング回数をこなすことが出来る
            </li>
            <li class="mb-2">
              期間内に必要な学習時間を確保出来る
            </li>
            <li class="mb-2">
              MacかWindowsのPCを持っている
            </li>
            <li class="mb-2">
              PCスペック：Photoshopの最小技術仕様を満たしている<span class="inline md:block">（詳細な内容は<a
                href="https://helpx.adobe.com/jp/photoshop/system-requirements.html"
                target="_blank"
              >こちら</a>）</span>
            </li>
            <li class="mb-2">
              Google Chrome を利用できる
            </li>
            <li class="mb-2">
              PCの基本的な操作が問題なくできる
            </li>
            <li>ビデオチャットが可能な通信環境</li>
          </template>
        </TeCommonPriceParticipationconditions>

        <div class="flex flex-col items-center lg:flex-row lg:items-start lg:gap-x-8">
          <!-- 注意事項 -->
          <TeCommonPricePrecautions />
          <!-- キャンセルポリシー -->
          <TeCommonPriceCancelPolicy />
        </div>
      </div>
    </section>

    <!-- 先割 -->
    <TeCourseSakiwari
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
    >
      <template #annotation02>
        <li>※4週間・8週間プランは先割の対象外です。</li>
      </template>
    </TeCourseSakiwari>

    <!-- トモ割 -->
    <TeCommonTomowari
      bg="#cdbf49"
      title-bg="#b2a431"
    />

    <!-- キャリアアップ支援事業 -->
    <TeCommonCareerUp
      :course="course"
    >
      <template #cashback>
        335,300
      </template>
    </TeCommonCareerUp>

    <!-- CTA -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-third"
    /> -->

    <!-- 他スクールとの比較 -->
    <TeCommonComparisonSchool
      :original-assignment="true"
      :benefits="true"
      :bannerguarantee="true"
    >
      <template #mentor>
        現役デザイナー
      </template>
      <template #teacher>
        デザイナー
      </template>
    </TeCommonComparisonSchool>

    <!-- 受講生のデモグラ -->
    <TeCourseWebdesignDemographics />

    <!-- お申し込みまでの流れ -->
    <TeCourseWebdesignFlow />

    <!-- FAQ -->
    <!-- 251202導線削除 -->
    <!-- <TeCourseWebdesignFaq /> -->

    <!-- PC初心者向けバナー -->
    <TeCommonBannerPcBeginner />

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <!-- 申込みフォーム -->
    <TeCourseApply
      :course="course"
      :cohorts="cohorts"
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
      :current-promotion="currentPromotion"
      :course-name-path="courseNamePath"
      :entry-discount-time-limit="entryDiscountTimeLimit"
      :entry-campaign="entryCampaign"
    />

    <!-- 251202導線削除 -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import { IndexServices } from '~/services/indexService'
import { scriptTag } from '~/utility/scriptTag'
import { getCohorts, getCurrentPromotion, getCourse } from '~/utility/fetchAPI'
import { getAdItem } from '~/utility/utility'

import TeCourseWebdesignCover from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignCover.vue'
import TeCommonPagenav from '~/components/Te/TeCommon/Pagenav/TeCommonPagenav.vue'
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonBannerSettlement from '~/components/Te/TeCommon/Banner/TeCommonBannerSettlement/TeCommonBannerSettlement.vue'
import TeCommonBannerTimelimit from '~/components/Te/TeCommon/Banner/TeCommonBannerTimelimit/TeCommonBannerTimelimit.vue'
import TeCommonBannerCampaign from '~/components/Te/TeCommon/Banner/TeCommonBannerCampaign/TeCommonBannerCampaign.vue'
import TeCourseAbout from '~/components/Te/TeCourse/TeCourseAbout.vue'
import TeCourseWebdesignPoint from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignPoint.vue'
import TeCourseWebdesignTarget from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignTarget.vue'
import TeCourseWebdesignGraduate from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignGraduate.vue'
import TeCommonBannerFreeTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerFreeTrial/TeCommonBannerFreeTrial.vue'
import TeCourseWebdesignOutput from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignOutput.vue'
import TeCourseWebdesignCurriculum from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignCurriculum.vue'
import TeCommonBannerAdobe from '~/components/Te/TeCommon/Banner/TeCommonBannerAdobe/TeCommonBannerAdobe.vue'
import TeCourseWebdesignMerit from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignMerit.vue'
import TeCourseWebdesignWork from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignWork.vue'
import TeCommonMentorSupportMentoring from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportMentoring/TeCommonMentorSupportMentoring.vue'
import TeCommonMentorSupportChatSupport from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportChatSupport/TeCommonMentorSupportChatSupport.vue'
import TeCommonMentorSupportIssueReview from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportIssueReview/TeCommonMentorSupportIssueReview.vue'
import TeCommonMentorSupportAboutFlow from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportAboutFlow/TeCommonMentorSupportAboutFlow.vue'
import TeCommonMentorSupportMentor from '~/components/Te/TeCommon/MentorSupportMentor/TeCommonMentorSupportMentor.vue'
import TeCommonMentorSupportReason from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportReason/TeCommonMentorSupportReason.vue'
import TeCommonLearningCycle from '~/components/Te/TeCommon/TeCommonLearningCycle/TeCommonLearningCycle.vue'
import TeCommonCampaign from '~/components/Te/TeCommon/TeCommonCampaign/TeCommonCampaign.vue'
import TeCommonPriceTimeLimit from '~/components/Te/TeCommon/Price/TeCommonPriceTimeLimit/TeCommonPriceTimeLimit.vue'
import TeCoursePriceTable from '~/components/Te/TeCourse/TeCoursePriceTable.vue'
import TeCoursePriceGreatPlan from '~/components/Te/TeCourse/TeCoursePriceGreatPlan.vue'
import TeCoursePriceInstallments from '~/components/Te/TeCourse/TeCoursePriceInstallments.vue'
import TeCommonPriceParticipationconditions from '~/components/Te/TeCommon/Price/TeCommonPriceParticipationconditions/TeCommonPriceParticipationconditions.vue'
import TeCommonPricePrecautions from '~/components/Te/TeCommon/Price/TeCommonPricePrecautions/TeCommonPricePrecautions.vue'
import TeCommonPriceCancelPolicy from '~/components/Te/TeCommon/Price/TeCommonPriceCancelPolicy/TeCommonPriceCancelPolicy.vue'
import TeCourseSakiwari from '~/components/Te/TeCourse/TeCourseSakiwari.vue'
import TeCommonTomowari from '~/components/Te/TeCommon/Tomowari/TeCommonTomowari.vue'
import TeCommonCareerUp from '~/components/Te/TeCommon/CareerUp/TeCommonCareerUp.vue'
import TeCourseWebdesignExample from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignExample.vue'
import TeCourseWebdesignCareerSupport from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignCareerSupport.vue'
import TeCommonComparisonSchool from '~/components/Te/TeCommon/Comparison/TeCommonComparisonSchool/TeCommonComparisonSchool.vue'
import TeCourseWebdesignDemographics from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignDemographics.vue'
import TeCourseWebdesignFlow from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignFlow.vue'
import TeCourseWebdesignFaq from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignFaq.vue'
import TeCommonBannerPcBeginner from '~/components/Te/TeCommon/Banner/TeCommonBannerPcBeginner/TeCommonBannerPcBeginner.vue'
import TeCourseApply from '~/components/Te/TeCourse/TeCourseApply.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faObjectGroup } from '@awesome.me/kit-65d95819ce/icons/classic/regular'

const options = {
  async setup() {
    const route = useRoute()
    const courseNamePath = route.path.split('/')[2]
    const course = ref<Object | null>(null)

    return {
      route,
      course,
      courseNamePath,
      faObjectGroup,
    }
  },
  oldHead() {
    const scriptTags = scriptTag({
      facebookPixelCode: true,
      criteoScript: true,
      criteoItem: {
        deviceSize: useNuxtApp().$deviceSize,
        item: this.course?.id,
      },
      remarketingTag: {
        ad_item_id: this.course?.id,
        ad_item_price: this.course ? getAdItem(this.course) : null,
      },
    })
    return {
      title: 'Webデザインをスクールで勉強/専属メンター付 | テックアカデミー',
      meta: [
        ...metaTags({
          description:
            '【テックアカデミー(TechAcademy)】選抜された現役デザイナーから学べるWebデザインの講座。受講者数No.1のオンラインプログラミングスクール。専属のパーソナルメンターがマンツーマンでサポート。',
          twitterTitle: 'Webデザインコース',
          twitterDescription:
            'Webデザインを選抜された現役デザイナーから自宅で学べる。パーソナルメンターがマンツーマンで学習サポート。',
          twitterImage: '/_nuxt/ogp/te/tecourse/og-image-webdesign.jpg',
          ogTitle: 'Webデザインコース',
          ogDescription:
            'Webデザインを選抜された現役デザイナーから自宅で学べる。パーソナルメンターがマンツーマンで学習サポート。',
          ogUrl: '/course/php',
          ogImage: '/_nuxt/ogp/te/tecourse/og-image-webdesign.jpg',
        }),
      ],
      script: scriptTags.script,
      noscript: scriptTags.noscript,
    }
  },
  data() {
    return {
      cohorts: [],
      latestCohort: null,
      sakiwariCohorts: [],
      currentPromotion: null,
      screenName: '',
      entryDiscountTimeLimit: null,
      entrySettlementTimeLimit: null,
      entryPaymentUrl: null,
      entryCampaign: null,
    }
  },
  async mounted() {
    const {
      data: {
        entryDiscountTimeLimit,
        entrySettlementTimeLimit,
        entryPaymentUrl,
        entryCampaign,
      },
    } = await new IndexServices(this.$api).getTopTimeLimits()
    this.entryDiscountTimeLimit = entryDiscountTimeLimit
    this.entrySettlementTimeLimit = entrySettlementTimeLimit
    this.entryPaymentUrl = entryPaymentUrl
    this.entryCampaign = entryCampaign

    const queryConfig = {
      course_screen_name: this.courseNamePath,
      normal_opened: true,
    }
    getCohorts(this.$api, queryConfig).then((response) => {
      this.cohorts = response.data
      this.latestCohort = response.data[0]
    })
    getCohorts(this.$api, {
      course_screen_name: this.courseNamePath,
      sakiwari: true,
    }).then((response) => {
      this.sakiwariCohorts = response.data
    })
    getCurrentPromotion(this.$api).then((response) => {
      this.currentPromotion = response.data
    })
    this.course = (
      await getCourse(this.$api, this.courseNamePath, { include_pack: true })
    )?.data
  },
  computed: {
    BannerNameForShowing() {
      if (this.entrySettlementTimeLimit) {
        return 'settlement'
      } else if (this.entryCampaign) {
        return 'campaign'
      } else if (this.entryDiscountTimeLimit) {
        return 'discount'
      } else {
        return null
      }
    },
    beginsAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.begins_at)
        : null
    },
    closesAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.closes_at)
        : null
    },
  },
  methods: {},
  components: {
    TeCourseWebdesignCover,
    TeCommonPagenav,
    TeCommonBannerTimeLimitCpnCode,
    TeCommonBannerSettlement,
    TeCommonBannerTimelimit,
    TeCommonBannerCampaign,
    TeCourseAbout,
    TeCourseWebdesignPoint,
    TeCourseWebdesignTarget,
    TeCourseWebdesignGraduate,
    TeCommonBannerFreeTrial,
    TeCourseWebdesignOutput,
    TeCourseWebdesignCurriculum,
    TeCommonBannerAdobe,
    TeCourseWebdesignMerit,
    TeCourseWebdesignWork,
    TeCommonMentorSupportMentoring,
    TeCommonMentorSupportChatSupport,
    TeCommonMentorSupportIssueReview,
    TeCommonMentorSupportAboutFlow,
    TeCommonMentorSupportMentor,
    TeCommonMentorSupportReason,
    TeCommonLearningCycle,
    TeCommonCampaign,
    TeCommonPriceTimeLimit,
    TeCoursePriceTable,
    TeCoursePriceGreatPlan,
    TeCoursePriceInstallments,
    TeCommonPriceParticipationconditions,
    TeCommonPricePrecautions,
    TeCommonPriceCancelPolicy,
    TeCourseSakiwari,
    TeCommonTomowari,
    TeCommonCareerUp,
    TeCourseWebdesignExample,
    TeCourseWebdesignCareerSupport,
    TeCommonComparisonSchool,
    TeCourseWebdesignDemographics,
    TeCourseWebdesignFlow,
    TeCourseWebdesignFaq,
    TeCommonBannerPcBeginner,
    TeCourseApply,
    TeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-section-h2-title {
  font-size: 1.5rem;
  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
}
</style>
